import { axiosApi } from 'shared/api/axios'
import { CounterpartiesEndpoint } from 'entities/counterparties/api/constant'
import { AddContactRequestDTO } from 'entities/counterparties/model/dtoTypes'

export const addContactToCounterparty = async (body: AddContactRequestDTO) => {
    try {
        await axiosApi.post(CounterpartiesEndpoint.contact, body)
    } catch (err) {
        console.error(err)
        throw err
    }
}
